/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessParentBody
 */
export interface UpdateBusinessParentBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessParentBody
     */
    parentId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessParentBody
     */
    purgeUsers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessParentBody
     */
    purgeStripe?: boolean;
}

/**
 * Check if a given object implements the UpdateBusinessParentBody interface.
 */
export function instanceOfUpdateBusinessParentBody(value: object): value is UpdateBusinessParentBody {
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    return true;
}

export function UpdateBusinessParentBodyFromJSON(json: any): UpdateBusinessParentBody {
    return UpdateBusinessParentBodyFromJSONTyped(json, false);
}

export function UpdateBusinessParentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessParentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'parentId': json['parentId'],
        'purgeUsers': json['purgeUsers'] == null ? undefined : json['purgeUsers'],
        'purgeStripe': json['purgeStripe'] == null ? undefined : json['purgeStripe'],
    };
}

export function UpdateBusinessParentBodyToJSON(json: any): UpdateBusinessParentBody {
    return UpdateBusinessParentBodyToJSONTyped(json, false);
}

export function UpdateBusinessParentBodyToJSONTyped(value?: UpdateBusinessParentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parentId': value['parentId'],
        'purgeUsers': value['purgeUsers'],
        'purgeStripe': value['purgeStripe'],
    };
}

